import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rate: {
    description: 'rateAndCreate.rate',
    defaultMessage: 'Rate: {formattedRate}',
    id: 'c6sXdV',
  },
  rateWarning: {
    description: 'rateAndCreate.rateWarning',
    defaultMessage: 'One or more of the selected shipments encountered a rating error.',
    id: '+ec/y4',
  },
  upgradePromotionalBannerTitle: {
    defaultMessage: 'Save on this shipment by upgrading to a paid plan.',
    description: 'Header message for the promotional banner that encourages users to upgrade their plan in order to see more rates',
    id: 'LFHM0l',
  },
});
